module.exports = __webpack_public_path__ + "img/Medellin.d518cbdc.png";